import * as authActions from '@auth/store/auth.actions';
import * as inventoryActions from '@inventory/store/inventory.actions';
import * as orderActions from '@orders/store/orders.actions';

import * as tempdataActions from './tempdata.actions';

export interface TempDataState {
  invSumGridData: any[];
  invDtlGridData: any[];
  invLotGridData: any[];
  ordInqGridData: any[];
  ordDtlGridData: any[];
  ordModHdrData: any;
  ordModDtlGridData: any[];
  reportListGridData: any[];
  userLookupGridData: any[];
  userLookupDetailData: any[];
}

export const initialState: TempDataState = {
  invSumGridData: null,
  invDtlGridData: null,
  invLotGridData: null,
  ordInqGridData: null,
  ordDtlGridData: null,
  ordModHdrData: null,
  ordModDtlGridData: null,
  reportListGridData: null,
  userLookupGridData: null,
  userLookupDetailData: null,
};

export function tempDataReducer(state = initialState, action: tempdataActions.TempDataActions) {
  switch (action.type) {
    case tempdataActions.INV_SUM_SET_GRID_DATA:
      return {
        ...state,
        invSumGridData: action.rowdata,
      };

    case tempdataActions.INV_SUM_CLEAR_GRID_DATA:
      return {
        ...state,
        invSumGridData: null,
      };

    case tempdataActions.INV_DTL_SET_GRID_DATA:
      return {
        ...state,
        invDtlGridData: action.rowdata,
      };

    case tempdataActions.INV_DTL_CLEAR_GRID_DATA:
      return {
        ...state,
        invDtlGridData: null,
      };

    case tempdataActions.INV_LOT_SET_GRID_DATA:
      return {
        ...state,
        invLotGridData: action.rowdata,
      };

    case tempdataActions.INV_LOT_CLEAR_GRID_DATA:
      return {
        ...state,
        invLotGridData: null,
      };

    case inventoryActions.INV_SUM_CLEAR_SELECT_ROW:
      return {
        ...state,
        invDtlGridData: null,
      };

    case inventoryActions.INV_DTL_CLEAR_SELECT_ROW:
      return {
        ...state,
        invLotGridData: null,
      };

    case tempdataActions.ORD_INQ_SET_GRID_DATA:
      return {
        ...state,
        ordInqGridData: action.rowdata,
      };

    case tempdataActions.ORD_INQ_CLEAR_GRID_DATA:
    case orderActions.ORD_INQ_REQUEST_DATA:
      return {
        ...state,
        ordInqGridData: null,
        ordDtlGridData: null,
      };

    case tempdataActions.ORD_DTL_SET_GRID_DATA:
      return {
        ...state,
        ordDtlGridData: action.rowdata,
      };

    case tempdataActions.ORD_DTL_CLEAR_GRID_DATA:
    case orderActions.ORD_INQ_CLEAR_SELECT_ROW:
      return {
        ...state,
        ordDtlGridData: null,
      };

    case tempdataActions.ORD_MOD_HDR_SET_DATA:
      return {
        ...state,
        ordModHdrData: action.data,
      };

    case tempdataActions.ORD_MOD_HDR_CLEAR_DATA:
    case orderActions.ORD_MOD_HDR_CREATE_INIT:
    case orderActions.ORD_MOD_HDR_CREATE_INBOUND_SUCCESS:
    case orderActions.ORD_MOD_HDR_CREATE_OUTBOUND_SUCCESS:
      return {
        ...state,
        ordModHdrData: null,
      };

    case tempdataActions.ORD_MOD_DTL_SET_GRID_DATA:
      return {
        ...state,
        ordModDtlGridData: action.rowdata,
      };

    case tempdataActions.ORD_MOD_DTL_CLEAR_GRID_DATA:
      return {
        ...state,
        ordModDtlGridData: null,
      };

    case tempdataActions.REPORT_LIST_SET_GRID_DATA:
      return {
        ...state,
        reportListGridData: action.reports,
      };

    case tempdataActions.REPORT_LIST_CLEAR_GRID_DATA:
      return {
        ...state,
        reportListGridData: null,
      };

    case tempdataActions.USER_LOOKUP_SET_GRID_DATA:
      return {
        ...state,
        userLookupGridData: action.rowdata,
      };

    case tempdataActions.USER_LOOKUP_CLEAR_GRID_DATA:
      return {
        ...state,
        userLookupGridData: null,
      };

    case tempdataActions.USER_DETAIL_LOOKUP_SET_DATA:
      return {
        ...state,
        userLookupDetailData: action.rowdata,
      };

    case tempdataActions.USER_DETAIL_LOOKUP_CLEAR_DATA:
      return {
        ...state,
        userLookupDetailData: null,
      };

    case inventoryActions.INV_SUM_INIT:
      return {
        ...state,
        invSumGridData: null,
        invDtlGridData: null,
        invLotGridData: null,
      };

    case orderActions.ORD_INQ_INIT:
      return {
        ...state,
        ordInqGridData: null,
        ordDtlGridData: null,
        ordModHdrData: null,
        ordModDtlGridData: null,
      };

    case orderActions.ORD_INQ_REINIT:
      return {
        ...state,
        ordDtlGridData: null,
        ordModHdrData: null,
        ordModDtlGridData: null,
      };

    case authActions.CHANGE_CUSTOMER:
      return initialState;

    case authActions.CHANGE_FACILITY:
      return initialState;

    default:
      return state;
  }
}
